import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1661176792532-b7d1442f4e27?auto=format&fit=crop&w=3840')",
        }}
      />
      <div className="absolute inset-0 bg-black/55" />

      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
        <p className="text-white/80 text-xs md:text-sm uppercase tracking-[0.35em] mb-6 animate-fadein">
          Accountability Through Consequences
        </p>
        <h1 className="font-serif text-white text-5xl md:text-7xl lg:text-8xl font-bold leading-[1.05] tracking-tight animate-fadeup">
          Real Spankings for<br />Real Reasons
        </h1>
        <p className="mt-8 text-white/90 text-lg md:text-xl font-light tracking-wide animate-fadeup-delay">
          Seattle, Tacoma, Everett and Bellevue Area Disciplinarian
        </p>
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4 animate-fadeup-delay2">
          <Link to="/session-request">
            <Button className="rounded-none bg-white text-neutral-900 hover:bg-neutral-100 h-12 px-8 text-sm tracking-widest uppercase group">
              Session Request <ArrowRight size={16} className="ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
          </Link>
          <Link to="/services">
            <Button variant="outline" className="rounded-none bg-transparent border-white text-white hover:bg-white hover:text-neutral-900 h-12 px-8 text-sm tracking-widest uppercase">
              Learn More
            </Button>
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/70 text-xs tracking-widest uppercase animate-bounce-slow">
        Scroll
      </div>
    </section>
  );
};

export default Hero;
